import { render } from "./UsuarioS.vue?vue&type=template&id=f1aa547e&scoped=true"
import script from "./UsuarioS.vue?vue&type=script&lang=js"
export * from "./UsuarioS.vue?vue&type=script&lang=js"

import "./UsuarioS.vue?vue&type=style&index=0&id=f1aa547e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1aa547e"]])

export default __exports__